import React, { useState, useCallback } from "react"
import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import { Button, Box, Stack } from "@mui/material"
import GenericHeaderReturnButton from "../../../components/GenericHeaderReturnButton"
import PackagingExecutionHeader from "../PackagingExecutionHeader"
import PackagingExecutionResume from "../packagingExecutionToValidate/PackagingExecutionResume"
import PackagingExecutionReprodInfo from "../packagingExecutionToValidate/PackagingExecutionReprodInfo"
import { showPackagingExecutionRead } from "../../../actions/PackagingExecution/packagingExecution"
import { validateAllPackagingExecutionRealNumbers } from "../../../actions/PackagingExecution/packagingExecution"
import { PE_STATUSES } from "../../../utils/packagingExecutions"
import { getFitCornerTag } from "../../../utils/productTagsUtils"
import PackagingExecutionFooter from "../PackagingExecutionFooter"
import PEStepper from "../PEStepper"
import PEBlockHead from "../packagingExecutionTodo/PEBlockHead"
import PackagingCountingForm from "./PackagingCountingForm"

const PackagingExecutionPackagingsCounting = ({ packagingExecution, selectedSite, selectedDate, hasSubStatus }) => {
	const dispatch = useDispatch()
	const [packagingUpdates, setPackagingUpdates] = useState([])
	const [isValidForm, setIsValidForm] = useState(false)

	const goToPackagingExecutionRead = () => {dispatch(showPackagingExecutionRead(selectedSite.objectId, selectedDate))}
	const hasReproductions = packagingExecution.sections.some(section => Array.isArray(section.reproductions) && section.reproductions.length > 0)
	const hasOngoingReproductions = packagingExecution.sections.some(section => (section.reproductions || []).some(reprod => reprod.status === "IN_PROGRESS"))

	const saveAllPackagingExecutionRealNumbers = useCallback(
		(packagingUpdates) => {
			const packagingExecutionId = packagingExecution.objectId
			if (packagingExecutionId)
				dispatch(validateAllPackagingExecutionRealNumbers(packagingExecutionId, packagingUpdates))
		},
		[packagingExecution]
	)

	return (
		<>
			<PackagingExecutionHeader
				leftAction={<GenericHeaderReturnButton handleClick={goToPackagingExecutionRead} />}
				subtitle={`${selectedSite.name} - ${dayjs(selectedDate).format("DD/MM/YYYY")}`}
				fixedHeader
			/>
			<Box sx={{ p: 3, marginTop: "65px" }}>
				<Stack direction="row" spacing={3}>
					<div className="flex1">
						<PackagingExecutionResume
							recipeLabel={packagingExecution.recipeName}
							status={PE_STATUSES.inProgress}
							packagingLine={packagingExecution.packagingLine?.name}
							expectedPackagingNumber={packagingExecution.expectedPackagingNumber}
							uniqueCode={packagingExecution.uniqueCode}
							hasSubStatus={hasSubStatus}
							fitCornerTag={getFitCornerTag(packagingExecution.recipe)}
						/>
					</div>
				</Stack>
				{hasReproductions && (
					<PackagingExecutionReprodInfo
						text={
							hasOngoingReproductions
								? "Une reprod a été demandée pour atteindre la quantité prévue."
								: "La reprod a bien été intégrée à vos quantités."
						}
					/>
				)}
			</Box>
			<PEStepper
				packagings={packagingExecution.packagings}
				status={packagingExecution.status}
				times={{
					theoreticalStartTime: packagingExecution.theoreticalStartTime,
					theoreticalEndTime: packagingExecution.theoreticalEndTime,
					startTime: packagingExecution.startTime,
					endTime: packagingExecution.endTime
				}}
				withTitle={false}
			/>
			<Box sx={{ px: 3, paddingTop: "40px", paddingBottom: "24px" }}>
				<Stack spacing={3}>
					<PEBlockHead
						icon="chart"
						title="Nombre de barquettes"
						description="Saisissez le nombre de barquettes jetables réalisées, et renseignez également, si besoin, le nombre de barquettes operculées et réemployables."
					/>
					<PackagingCountingForm
						packagings={packagingExecution.packagings}
						onChange={setPackagingUpdates}
						isValidForm={setIsValidForm}
					/>
				</Stack>
			</Box>

			<PackagingExecutionFooter
				fixed
				rightAction={
					<Stack direction="row" spacing={2}>
						<Button
							variant="contained"
							disabled={!isValidForm}
							onClick={() => saveAllPackagingExecutionRealNumbers(packagingUpdates)}>
							Passer à la pesée des restes
						</Button>
					</Stack>
				}
			/>
		</>
	)
}

export default PackagingExecutionPackagingsCounting